// Braden Scale section form field enum
export enum BradenScaleFormField {
  BRADEN_SCALE_SENSORY_QUESTION = 'bradenScale/sensory',
  BRADEN_SCALE_SENSORY_NOTES = 'bradenScale/sensoryNotes',
  BRADEN_SCALE_MOISTURE_QUESTION = 'bradenScale/moisture',
  BRADEN_SCALE_MOISTURE_NOTES = 'bradenScale/moistureNotes',
  BRADEN_SCALE_ACTIVITY_QUESTION = 'bradenScale/activity',
  BRADEN_SCALE_ACTIVITY_NOTES = 'bradenScale/activityNotes',
  BRADEN_SCALE_MOBILITY_QUESTION = 'bradenScale/mobility',
  BRADEN_SCALE_MOBILITY_NOTES = 'bradenScale/mobilityNotes',
  BRADEN_SCALE_NUTRITION_QUESTION = 'bradenScale/nutrition',
  BRADEN_SCALE_NUTRITION_NOTES = 'bradenScale/nutritionNotes',
  BRADEN_SCALE_FRICTION_AND_SHEAR_QUESTION = 'bradenScale/frictionAndShear',
  BRADEN_SCALE_FRICTION_AND_SHEAR_NOTES = 'bradenScale/frictionAndShearNotes'
}
